// src/components/ui/BottomNav.jsx
import { Home, ArrowUpDown, PieChart, TrendingUp, Sparkles } from "lucide-react";
import { cn } from "../../lib/utils";

const tabs = [
  { id: "dashboard", label: "Home", Icon: Home },
  { id: "transactions", label: "Transactions", Icon: ArrowUpDown },
  { id: "spending", label: "Spending", Icon: PieChart },
  { id: "investments", label: "Invest", Icon: TrendingUp },
  { id: "ai", label: "Ask AI", Icon: Sparkles },
];

export function BottomNav({ active, onChange }) {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 bg-background-secondary border-t border-border bottom-nav-safe">
      <div className="flex items-stretch max-w-lg mx-auto">
        {tabs.map(({ id, label, Icon }) => {
          const isActive = active === id;
          return (
            <button
              key={id}
              onClick={() => onChange(id)}
              className={cn(
                "flex-1 flex flex-col items-center justify-center py-3 gap-1 transition-all duration-200 relative",
                isActive ? "text-accent-green" : "text-text-tertiary"
              )}
            >
              {isActive && (
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-accent-green rounded-full" />
              )}
              <Icon
                size={20}
                strokeWidth={isActive ? 2 : 1.5}
                className="transition-all duration-200"
              />
              <span
                className={cn(
                  "text-[10px] font-medium tracking-wide transition-all duration-200",
                  isActive ? "text-accent-green" : "text-text-tertiary"
                )}
              >
                {label}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
}
